import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/apiClient";
import { Key } from "@phosphor-icons/react";

export default function ResetPassword() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [token, setToken] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => { setToken(params.get("token") || ""); }, [params]);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pw.length < 6) return setErr(t("reset.pwMin"));
    if (pw !== pw2) return setErr(t("reset.mismatch"));
    if (!token) return setErr(t("reset.missing"));
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success(t("reset.success"));
      setTimeout(() => nav("/login"), 900);
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="reset-password-page" className="min-h-[70vh] flex items-center justify-center text-white px-6 py-16">
      <div className="w-full max-w-md">
        <div className="overline mb-3">{t("reset.overline")}</div>
        <h1 className="font-display text-4xl mb-2 flex items-center gap-3">
          <Key size={26} weight="duotone" className="text-[#E6C998]" />
          {t("reset.title")}
        </h1>
        <p className="text-neutral-400 mb-8 text-sm">
          {t("reset.subtitle")}
        </p>

        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="block text-xs uppercase tracking-wider text-neutral-400 mb-2">{t("reset.newPassword")}</label>
            <input data-testid="reset-pw" type="password" value={pw}
              onChange={(e) => setPw(e.target.value)}
              className="lux-input" required minLength={6} />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-wider text-neutral-400 mb-2">{t("reset.confirmPassword")}</label>
            <input data-testid="reset-pw2" type="password" value={pw2}
              onChange={(e) => setPw2(e.target.value)}
              className="lux-input" required minLength={6} />
          </div>
          {err && <div data-testid="reset-error" className="text-sm text-red-400">{err}</div>}
          <button data-testid="reset-submit" type="submit" disabled={busy}
            className="btn-gold w-full py-4 rounded-none text-sm disabled:opacity-60">
            {busy ? t("reset.submitting") : t("reset.submit")}
          </button>
          <div className="text-xs text-neutral-500">
            {t("reset.or")} <Link to="/login" className="text-[#E6C998]">{t("reset.back")}</Link>.
          </div>
        </form>
      </div>
    </div>
  );
}
